export default __webpack_public_path__ + "static/media/schools and colleges.57f3984a.webp";